import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { Reveal, Eyebrow } from "../components/site/Reveal";
import { CTA } from "../components/site/CTA";
import { SERVICES } from "../data/services";

export default function ServiceDetail() {
  const { slug } = useParams();
  const s = SERVICES.find((x) => x.slug === slug);
  if (!s) return <Navigate to="/services" replace />;
  const others = SERVICES.filter((x) => x.slug !== slug);

  return (
    <>
      <PageHero testid="service-detail-hero" eyebrow={`${s.code} · ${s.kicker}`} lines={[s.title]} intro={s.intro} />
      <section className="bg-paper py-24 sm:py-32">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-7">
            <Eyebrow>Scope of engagement</Eyebrow>
            <ul data-testid="service-scope-list" className="mt-10 border-t border-ink/15">
              {s.scope.map((item, i) => (
                <Reveal as="li" key={item} delay={i * 0.05} className="flex gap-5 py-6 border-b border-ink/15">
                  <span className="mt-0.5 grid place-items-center w-8 h-8 shrink-0 rounded-full bg-ink text-brass"><Check className="w-4 h-4" /></span>
                  <span className="text-lg sm:text-xl font-medium leading-snug">{item}</span>
                </Reveal>
              ))}
            </ul>
          </div>
          <Reveal className="lg:col-span-5" delay={0.1}>
            <div className="lg:sticky lg:top-32 overflow-hidden rounded-[24px] bg-ink text-paper">
              <img src={s.image} alt={s.title} className="w-full aspect-[16/10] object-cover opacity-80" />
              <div className="p-8">
                <p className="font-display font-bold text-2xl">Discuss your {s.code} compliance</p>
                <p className="mt-3 text-paper/75">Share your current set-up and we'll suggest a scope that fits.</p>
                <Link to="/contact" state={{ entity: s.title }} data-testid="service-enquire-button" className="group mt-6 inline-flex items-center gap-2 rounded-full bg-brass text-paper px-6 py-3 font-semibold hover:bg-paper hover:text-ink transition-colors">
                  Enquire now <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
                </Link>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
      <section className="bg-paper-2 py-20">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
          <Eyebrow>Other verticals</Eyebrow>
          <div className="mt-8 flex flex-wrap gap-3">
            {others.map((o) => (
              <Link key={o.slug} to={`/services/${o.slug}`} data-testid={`other-service-${o.slug}`} className="rounded-full border border-ink/25 px-5 py-2.5 font-medium hover:bg-ink hover:text-paper transition-colors duration-300">
                {o.title}
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CTA />
    </>
  );
}
